import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { lighten, useTheme } from '@mui/material/styles'
import { FormSectionProps } from '../../interfaces/form'
import { useForm } from 'react-final-form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import FormWizard from '../wizard'
import FormRadio from '../../components/FormRadio'
import { useEffect, useState } from 'react'

const radioStyle = {
  paddingBottom: 0,
  display: 'none',
}

const radioOverrideMuiStyle = {
  '&.MuiRadio-root': {
    '&.Mui-checked + span': {
      backgroundColor: `primary.main`,
      color: '#FFF !important',
    },
  },
}

const textStyle = {
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  display: 'inline-flex',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: 'primary.main',
  marginTop: 0,
  marginRight: '6px',
  marginBottom: '10px',
  fontWeight: 'bold',
  verticalAlign: 'top',
  width: '100%',
  height: '100%',
  minHeight: 80,
  cursor: 'pointer',
}

const HouseHold = ({ validate }: FormSectionProps) => {
  const form = useForm()
  const theme = useTheme()

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 8 }}>
            Now, let's work out your cover needs. Who's in your household?
          </Typography>
          <Grid container spacing={2} sx={{ mb: 14 }}>
            <Grid item xs={12} md={6}>
              <label htmlFor="just-me" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="just-me"
                  name="household"
                  value="Just me"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('household', 'Just me')
                    form.change('otherMonthlyExpenses', 859)
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Just me
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label
                htmlFor="me-and-my-children"
                style={{ textAlign: 'center' }}
              >
                <FormRadio
                  id="me-and-my-children"
                  name="household"
                  value="Me and my children"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('household', 'Me and my children')
                    form.change('otherMonthlyExpenses', 859 + 2548)
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Me and my children
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label
                htmlFor="me-and-my-partner"
                style={{ textAlign: 'center' }}
              >
                <FormRadio
                  id="me-and-my-partner"
                  name="household"
                  value="Me and my partner"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('household', 'Me and my partner')
                    form.change('otherMonthlyExpenses', 859 * 2)
                    form.change('isPartnerCovered', '')
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Me and my partner
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label
                htmlFor="me-my-partner-my-children"
                style={{ textAlign: 'center' }}
              >
                <FormRadio
                  id="me-my-partner-my-children"
                  name="household"
                  value="Me, my partner and my children"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('household', 'Me, my partner and my children')
                    form.change('otherMonthlyExpenses', 859 * 2 + 2548)
                    form.change('isPartnerCovered', '')

                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Me, my partner and my children
                </Typography>
              </label>
            </Grid>
          </Grid>
          <Typography variant="body1" fontSize={16} sx={{ mb: 8 }}>
            We only need to know about people who rely on you financially or you
            have shared financial commitments with (like a mortgage).
          </Typography>
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default HouseHold
